import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import VoucherListItem from '@/components/voucher-list-item';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import MoreUnusableVouchers from '@/components/more-unusable-vouchers';
import { useGetVouchers } from '@/services/hooks';
import { useEffect } from 'react';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import { VouchersProps } from '@/components/vouchers-section/types';
import cn from '@/lib/clsxm';
import useHomeStore from '@/store/home';
import AssetLoading from '@/components/@base/asset-loading';
import { getFromSessionStorage, isDesktop } from '@/lib/helper';
import FontIcon from '@/components/@base/font-icon';
import useCommonModalStore from '@/store/common-modal-store';
const  VouchersSection = () => {
  const { setShowBottomSheet } = useBottomSheetStore();
  const { setShow } = useCommonModalStore();
  const {
    usableClientVouchers,
    setUsableClientVouchers,
    setUnUsableVoucherAcceptorMerchants,
    setUnUsableVoucherMinimumInvoiceAmounts,
    setUnUsableVoucherPermissionItems,
    setMaximumConcurrentUseCount,
    unUsableVoucherAcceptorMerchants,
    unUsableVoucherPermissionItems,
    unUsableVoucherMinimumInvoiceAmounts
  } = useUserWalletsVouchersStore()
  const { invoice } = useHomeStore();
  const {data, isLoading, isError} = useGetVouchers(invoice > 0)
  const showMoreVouchers = () => {
    if (isDesktop()) {
      setShow(true, {
        center: true,
        Body: () => <MoreUnusableVouchers />,
      });
    } else {
      setShowBottomSheet(true, {
        Body: () => <MoreUnusableVouchers />,
      });
    }
   
  }
  useEffect(() => {
    if(data?.usableClientVouchers) {
      if(data?.usableClientVouchers?.length === 0) sessionStorage.setItem('vouchersIsEmpty','true')
      const editedVouchers:VouchersProps[] = []
      data?.usableClientVouchers?.map((s:any) => {
        editedVouchers.push({
          ...s,
          selected: false,
          usageBalance: 0
        })
      })
      setUsableClientVouchers(editedVouchers);
    }
    if(data?.unUsableVoucherAcceptorMerchants) setUnUsableVoucherAcceptorMerchants(data?.unUsableVoucherAcceptorMerchants)
    if(data?.unUsableVoucherMinimumInvoiceAmounts) setUnUsableVoucherMinimumInvoiceAmounts(data?.unUsableVoucherMinimumInvoiceAmounts)
    if(data?.unUsableVoucherPermissionItems) setUnUsableVoucherPermissionItems(data?.unUsableVoucherPermissionItems)
    if(data?.maximumConcurrentUseCount) setMaximumConcurrentUseCount(data?.maximumConcurrentUseCount)
  }, [data]);
  if(!usableClientVouchers || usableClientVouchers?.length === 0) return null;
  return (
    <Container center className='mt-3 w-full flex-col rounded-xl'>
      <Container
        center
        className='w-full justify-between gap-2 pb-3 pl-[22px] pr-3 pt-5 md:justify-start'
      >
        <Text className='text-lg text-grayLight-1000 dark:text-grayLight-0' medium>
          {localization.discounts}
        </Text>
        {getFromSessionStorage('editableWallets') && (
          <FontIcon
            icon='icon-circle-information'
            className={cn(
              'cursor-pointer text-xl text-grayLight-650 dark:text-grayLight-650',
              unUsableVoucherAcceptorMerchants?.length === 0 &&
                unUsableVoucherPermissionItems?.length === 0 &&
                unUsableVoucherMinimumInvoiceAmounts?.length === 0 &&
                'hidden',
            )}
            onClick={showMoreVouchers}
          />
        )}
      </Container>
      {isLoading && <AssetLoading />}
      {(usableClientVouchers?.length === 0 || isError) && !isLoading && (
        <Container className='mx-auto flex w-full justify-start gap-3 py-4 pr-4'>
          <Text className='text-[13px] text-grayLight-600 dark:text-grayDark-300'>
            {localization.youHaveNoVouchers}
          </Text>
        </Container>
      )}
      {data?.maximumConcurrentUseCount &&
        usableClientVouchers?.length > 0 &&
        usableClientVouchers?.length > data?.maximumConcurrentUseCount && (
          <Text className='mb-3 w-full pr-3 text-right text-sm text-blue dark:text-blue-200'>
            {localization.maximumVoucherInvoice(data?.maximumConcurrentUseCount)}
          </Text>
        )}
      <Container className='w-full'>
        {usableClientVouchers?.map((item, index) => (
          <VoucherListItem
            className='lg:first:rounded-t-xl lg:last:rounded-b-xl'
            data={item}
            key={index}
          />
        ))}
      </Container>
    </Container>
  );
}
export default VouchersSection